import React, { useContext, useState, useRef, useEffect } from "react"; // removed useEffect
import ReactGA from "react-ga4";
import styles from "./LeaderboardPrev.module.scss";
import { Context } from "../Store";
import { capitalize } from "../utils/helpers";
import { useHistory, useParams } from "react-router-dom";

const LeaderboardPrev = ({ visibleCount = 6 }) => {
  const [state] = useContext(Context);
  const [showAll, setShowAll] = useState(false);

  const scrollContainerRef = useRef(null);
  const scrollIndicatorRef = useRef(null);

  const { parsedPlayers = [] } = state;
  const history = useHistory();
  const { guid } = useParams();

  let trackEvent = (category, action, label = "") => {
    ReactGA.event({ category, action, label });
  };

  const getOrdinalSuffix = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  };

  const TitleRow = () => (
    <div className={`${styles.row} ${styles.titleRow}`}>
      <span className={styles.cell}>RANK</span>
      <span className={styles.cell}>NAME</span>
      <span className={styles.cell}>POINTS</span>
      <span className={styles.cell}>
        <img src="./img/gold_medal.png" alt="Gold" />
      </span>
      <span className={styles.cell}>
        <img src="./img/silver_medal.png" alt="Silver" />
      </span>
      <span className={styles.cell}>
        <img src="./img/bronze_medal.png" alt="Bronze" />
      </span>
    </div>
  );

  const PlayerRow = ({ player, index }) => (
    <div className={`${styles.row} ${styles[`row_${index}`] || ""}`}>
      <span className={styles.cell}>
        {index + 1}
        <sup>{getOrdinalSuffix(index + 1)}</sup>
      </span>
      <span className={styles.cell}>{capitalize(player.name)}</span>
      <span className={styles.cell}>{player.points}</span>
      <span className={styles.cell}>{player.gold}</span>
      <span className={styles.cell}>{player.silver}</span>
      <span className={styles.cell}>{player.bronze}</span>
    </div>
  );

  const visiblePlayers = showAll ? parsedPlayers : parsedPlayers.slice(0, visibleCount);

  // scroll handler for indicator
  const handleScroll = () => {
    const container = scrollContainerRef.current;
    const indicator = scrollIndicatorRef.current;
    if (!container || !indicator) return;

    const scrollWidth = container.scrollWidth - container.clientWidth;
    const percent = scrollWidth > 0 ? (container.scrollLeft / scrollWidth) * 100 : 0;
    // Add 40% starting width
    indicator.style.width = `${50 + percent * 0.5}%`;
  };

  useEffect(() => {
    if (scrollIndicatorRef.current) {
      scrollIndicatorRef.current.style.width = "50%"; // start at 40%
    }
  }, []);


  return (
    <div className={`${styles.lbSection} section section--padded`}>
      <h2>Leaderboard</h2>

      <div
        className={styles.scrollContainer}
        ref={scrollContainerRef}
        onScroll={handleScroll}
      >
        <TitleRow />
        {visiblePlayers.map((player, index) => (
          <PlayerRow key={player.id} player={player} index={index} />
        ))}
      </div>

      {/* Scroll indicator */}
      <div className={styles.scrollIndicatorContainer}>
        <div ref={scrollIndicatorRef} className={styles.scrollIndicator} />
      </div>

      {parsedPlayers.length > visibleCount && (
        <button
          className={`secondaryButton ${styles.showMoreBtn}`}
          onClick={() => {
            const newState = !showAll;
            setShowAll(newState);
            trackEvent(
              "UI Interaction",
              `Toggle ${newState ? "Show More" : "Show Less"}`
            );
          }}
        >
          {showAll ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );
};

export default LeaderboardPrev;
